// eslint-disable-next-line no-unused-vars
import React from 'react'
import { Alert, Snackbar } from '@mui/material'
import { EventType, Message, Severity } from '@3m5/crude-frontend/dist/shared/types/messageTypes'

const SnackbarComponent: React.FC = () => {
  // const storedMessage: Message | undefined = useSelector(getMessage)
  const defaultHideDuration = 3 * 1000

  const [open, setOpen] = React.useState<boolean>(false)
  const [message, setMessage] = React.useState<Message | undefined>()
  const [hideDuration, setHideDuration] = React.useState<number | null>(defaultHideDuration)

  const handleClose = () => {
    setOpen(false)
  }

  window.addEventListener('CrudeMessages', (({ detail }: CustomEvent) => {
    const tempMessage: Message = detail
    if (tempMessage.eventType !== EventType.load) {
      setMessage(tempMessage)
      setOpen(true)
      setHideDuration(tempMessage && tempMessage.severity === Severity.error ? null : defaultHideDuration)
    }
  }) as EventListener)

  return (
    <Snackbar open={open} autoHideDuration={hideDuration} onClose={handleClose}>
      <Alert variant='filled' onClose={handleClose} severity={message && message.severity} sx={{ width: '100%' }}>
        {message && message.message}
      </Alert>
    </Snackbar>
  )
}

export default SnackbarComponent
